import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// 班级
import cls from "./cls";
import cstudent from "./cstudent";
import clesson from "./clesson";
import study from "./study";

// 学校
import school from "./school";
import college from "./college";
import student from "./student";

// 专业
import major from "./major";

// 教室
import classroom from "./classroom";

// 老师
import teacher from "./teacher";

// 课程
import lesson from './lesson';
import lmodule from './lmodule';
import lchapter from "./lchapter";

// 账户
import user from './user';

// 标签
import flag from './flag';

// 简历
import resume from './resume';

// 货物
import psi from './psi';

// 工资
import sabill from "./sabill";
import salary from "./salary";

// 员工
import employee from './employee';
import empcontract from "./empcontract";

// 职位
import job from './job';

// 企业
import enterprise from "./enterprise";
import entercontract from "./entercontract";

// 主页
import home from "./home";

// 用户
import manager from './manager';
// 个人中心
import center from './center';
// 错误
import error from './error';
// 系统设置
import system from "./system";

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    mode: 'history',
    routes: [
        ...cls,
        ...cstudent,
        ...clesson,
        ...study,

        ...school,
        ...college,
        ...student,

        ...major,

        ...classroom,

        ...teacher,

        ...lesson,
        ...lmodule,
        ...lchapter,

        ...user,

        ...flag,

        ...resume,

        ...psi,

        ...sabill,
        ...salary,

        ...employee,
        ...empcontract,

        ...job,

        ...enterprise,
        ...entercontract,

        ...home,

        ...manager,
        ...center,
        ...error,
        ...system,
    ],
});
